import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbCardModule } from '@nebular/theme';
import { DataViewModule } from 'primeng/dataview';
import { PaginatorModule } from 'primeng/paginator';
import { CustomInputNumberModule } from '../custom-input-number/custom-input-number.module';
import { ProductGridComponent } from './product-grid.component';
import { ComponentsModule } from 'app/component/components.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ProductGridComponent
  ],
  imports: [
    CommonModule,
    CustomInputNumberModule,
    DataViewModule,
    NbCardModule,
    PaginatorModule,
    ComponentsModule,
    ProgressSpinnerModule,
  ],
  exports: [
    ProductGridComponent
  ]
})
export class ProductGridModule { }
